import { FormHelperText } from "@mui/material";
import { TextFieldHookFormProps } from "components/TextField";
import { MuiOtpInput } from "mui-one-time-password-input";
import {
  Controller,
  FieldPath,
  FieldValues,
  get,
  useFormContext,
} from "react-hook-form";

const OTPInputHookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  defaultValue,
  rules,
  shouldUnregister,
  setPropsWithFormState,
  ...innerProps
}: TextFieldHookFormProps<TFieldValues, TName>) => {
  const { control } = useFormContext<TFieldValues>();

  const matchIsNumeric = (text: any) => {
    const isNumber = typeof text === "number";
    const isString = typeof text === "string";
    return (
      (isNumber || (isString && text !== "")) && !Number.isNaN(Number(text))
    );
  };

  const validateChar = (value: any, index: any) => {
    return matchIsNumeric(value);
  };

  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      control={control}
      render={(formState) => {
        const {
          field: { disabled, ref, onChange, ...innerField },
          formState: { errors },
        } = formState;
        const error = get(errors, name);
        const errorMsg = error?.message;
        const helperText =
          typeof errorMsg === "string" ? errorMsg : innerProps?.helperText;
        return (
          <>
            <MuiOtpInput
              // {...innerProps}
              // {...innerField}
              TextFieldsProps={{ placeholder: "0" }}
              validateChar={validateChar}
              marginY={8}
              value={innerField?.value as string}
              length={6}
              onChange={onChange}
              sx={{
                ".MuiInputBase-input": {
                  padding: "2px 7px !important",
                  fontSize: "36px !important",
                  height: "44px !important",
                  caretColor: "transparent",
                  color: "transparent",
                  textShadow: "0 0 0 black",
                },
              }}
            />
            {helperText ? (
              <FormHelperText
                variant="outlined"
                required={innerProps.required}
                error={errorMsg}
                disabled={innerProps.disabled}
              >
                {helperText}
              </FormHelperText>
            ) : null}
          </>
        );
      }}
    />
  );
};

export default OTPInputHookForm;
